import React from "react";
import LogoImage from './assets/AirNet_logo.svg'
import './Logo.css';

export default function Logo()
{
    return <img className="logo" src={ LogoImage } alt="airnet-logo"></img>
}